module.exports = __webpack_public_path__ + "dcd695cce1390d295bdb0911015469b1.svg";